var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioLeftNavSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100mm",
    height: "13.381626mm",
    viewBox: "0 0 100 13.381628",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.087878
    },
    id: "rect4",
    width: 99.912125,
    height: 0.032122012,
    x: 0.043938994,
    y: 13.330564
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0550468
    },
    id: "rect4-30",
    width: 13.261739,
    height: 0.094953246,
    x: 0.027523378,
    y: -50.122475,
    transform: "rotate(90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioLeftNavSvg);
export default __webpack_public_path__ + "static/media/portfolio_left_nav_svg.c838def14edbce6a1bcc456d015abf59.svg";
export { ForwardRef as ReactComponent };